class menuMobile
{
    init()
    {
        $('.nav-mobile .menu-item-has-children > a span.icon').on('click', function(e) {
            e.preventDefault();

            let $clicked = $(this).parent().parent();

            $clicked.toggleClass('active');

            if ($clicked.hasClass('active')) {
                $clicked.find('.sub-menu').slideDown(300);
            } else {
                $clicked.find('.sub-menu').slideUp(300);
            }
        });
    }
}

export default new menuMobile();


// WEBPACK FOOTER //
// ./scripts/src/menuMobile.js